package ru.dinarastepina.fabvocab.web.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import org.jetbrains.compose.web.css.LineStyle
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px
import ru.dinarastepina.fabvocab.web.theme.*

@Composable
fun FeedbackCard(
    message: String,
    isError: Boolean = true,
    modifier: Modifier = Modifier,
) {
    val background = if (isError) Rose50 else Emerald50
    val textColor = if (isError) Rose600 else Emerald600
    val borderColor = Slate100

    Box(
        modifier = modifier
            .fillMaxWidth()
            .backgroundColor(background)
            .border(2.px, LineStyle.Solid, borderColor)
            .borderRadius(16.px)
            .padding(14.px),
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            SpanText(
                if (isError) "⚠" else "✓",
                modifier = Modifier
                    .fontSize(18.px)
                    .margin(right = 8.px)
                    .color(textColor),
            )
            SpanText(
                message,
                modifier = Modifier
                    .fontSize(14.px)
                    .fontWeight(FontWeight.SemiBold)
                    .color(textColor),
            )
        }
    }
}
